import React from 'react';
import {makeStyles} from "@mui/styles";
import {Box} from "@mui/material";

const useStyles = makeStyles(() => ({
    root: {
        padding: 16,
        border: "1px solid rgb(217, 217, 217)",
        gap: 20,
        borderRadius: 10,
        margin: "16px 0",
        background: "#fff"
    },
    img: {
        minWidth: 64,
        minHeight: 64,
        "& img": {
            width: "100%",
            height: "100%",
            objectFit: "contain"
        }
    },
    title: {
        color: "#757575",
        fontSize: "16px"
    },
    description: {
        color: "#757575",
        fontSize: "14px"
    }
}));

interface Props {
    readonly title: string;
    readonly description: string;
}

export function InfoBanner({title, description}: Props) {
    const classes = useStyles();

    return (
        <Box sx={{display: "flex", alignItems: "center"}} className={classes.root}>
            <div className={classes.img}>
                <img src="https://reactjs.org/favicon.ico" alt=""/>
            </div>
            <div>
                <h2 className={classes.title}>{title}</h2>
                <p className={classes.description}>{description}</p>
            </div>
        </Box>
    );
}

